import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../assets/styles/themes/tokens';
import MasterLayout from '../../../components/AppLayout/MasterLayout';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { routes } from '../../../constants';
import type { IconName } from '../../../utils/getMuiIcon';
import searchFiltersToQuery from '../../../utils/searchFiltersToQuery';
import searchResultsStorageManager from '../../../utils/searchResultsStorageManager';
import useScreenSize from '../../../utils/useScreenSize';
import CourseCoverPageAuthors from './CourseCoverPageAuthors';
import CourseCoverPageCertificatesBanner from './CourseCoverPageCertificatesBanner';
import { CourseCoverPageProvider } from './CourseCoverPageProvider';
import CourseCoverPageSummary from './CourseCoverPageSummary';

const CourseCoverPage = () => {
	const { isXsScreen } = useScreenSize();
	const { t } = useTranslation();

	const storageSessionCourseSearchFilters = searchResultsStorageManager.getCourseSearchFilters();
	const searchPageUrl = `/${routes.courseCatalog.root}?${searchFiltersToQuery(storageSessionCourseSearchFilters)}`;

	const summaryWrapperPadding = isXsScreen
		? `${spaces.lg} ${spaces.md} ${spaces.xl} ${spaces.md}`
		: `${spaces.lg} ${spaces.xl} ${spaces.xxxl} ${spaces.xl}`;

	const bodyWrapperPadding = isXsScreen
		? `${spaces.xl} ${spaces.md} ${spaces.xxxxxl} ${spaces.md}`
		: `${spaces.xxxl} ${spaces.xl} ${spaces.xxxxxl} ${spaces.xl}`;

	return (
		<MasterLayout
			customTopBarContent={
				<Breadcrumbs
					links={[
						{
							title: t('Search'),
							url: searchPageUrl,
							iconName: 'searchDone' as IconName,
						},
						{
							title: t('Course overview'),
							iconName: 'book' as IconName,
						},
					]}
				/>
			}
			forceNewNavigation
		>
			<CourseCoverPageProvider>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						width: '100%',
						margin: 'auto',
						backgroundColor: palette.background.paperElevation2,
						padding: summaryWrapperPadding,
					}}
				>
					<CourseCoverPageSummary />
				</Box>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						width: '100%',
						margin: 'auto',
						backgroundColor: palette.background.paperElevation1,
						padding: bodyWrapperPadding,
						gap: spaces.md,
					}}
				>
					<CourseCoverPageCertificatesBanner />
					<CourseCoverPageAuthors />
				</Box>
			</CourseCoverPageProvider>
		</MasterLayout>
	);
};

export default CourseCoverPage;
